import Navbar from "../components/Navbar.jsx";
import HeroSection from "../components/HeroSection.jsx";
import FilterBar from "../components/FilterBar.jsx";
import CategoryGrid from "../components/CategoryGrid.jsx";
import Footer from "../components/Footer.jsx";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <Footer />
    </div>
  );
};

export default Index;